import type { ChangelogListResponse } from '@mentorivo/shared';

import { api } from '@/lib/api';

/**
 * Değişiklik günlüğünün istemcisi — YALNIZCA SUNUCUDA çağrılır.
 *
 * ---------------------------------------------------------------------------
 * Neden istemci bileşeninden çağrılmıyor
 * ---------------------------------------------------------------------------
 * `blog-api.ts` ile aynı gerekçe: bu sayfa arama motorunun okuması gereken
 * içerik. Tarayıcıdan çekilseydi HTML boş gelir, metin ancak JavaScript
 * çalıştıktan sonra dolardı. `lib/api.ts` sunucudan `127.0.0.1:3040`a gidiyor
 * — nginx'e ve IP kısıtına hiç uğramadan.
 *
 * Burada ek bir sebep var: `/changelog` bir ürünün YAŞADIĞINI gösteren sayfa
 * ve bu tam olarak arama sonucunda görünmesi istenen şey.
 *
 * ---------------------------------------------------------------------------
 * Önbellek: 60 saniye
 * ---------------------------------------------------------------------------
 * Blogla aynı pencere ve aynı denge: ziyaretçi başına bir API çağrısı
 * yapılmıyor, panelden yapılan bir düzeltme de en geç bir dakikada yayına
 * giriyor.
 *
 * ⚠️ Burada pencerenin bir anlamı daha var: sayfa bir DUYURU yüzeyi. Yeni bir
 * sürüm kaydı yayına alındığında ekip onu hemen görmek istiyor; saatlik bir
 * `revalidate`, "yayınladım ama sitede yok" telaşı üretirdi.
 */
const REVALIDATE_SECONDS = 60;

export const changelogApi = {
  /**
   * Yayındaki kayıtların tamamı — satırlarıyla birlikte.
   *
   * `kind` süzgeci GÖNDERİLMİYOR bilinçli: kayıtların hepsi bir kerede geliyor
   * ve süzgeç istemcide çalışıyor (`components/changelog-list.tsx`). Türe
   * basıldığında ağa çıkılsaydı kayan işaret (`layoutId`) her basışta
   * beklemeye girerdi.
   */
  list: (locale: string) =>
    api.get<ChangelogListResponse>(`/changelog/entries?locale=${encodeURIComponent(locale)}`, {
      next: { revalidate: REVALIDATE_SECONDS },
    }),
};

/**
 * Bir kaydın kalıcı bağlantısı.
 *
 * Tek yerde duruyor ki sayfadaki çıpa (`id`) ile bağlantı (`href`) aynı
 * biçimden doğsun. Detay sayfası YOK — adres her zaman listenin kendisi artı
 * çıpa (gerekçe `packages/shared/src/changelog.ts` → `changelogSlugSchema`).
 *
 * Dil ön eki yok: `@/i18n/navigation`ın `Link`i onu kendisi ekliyor. Sayfa
 * içi çıpalarda zaten gerekmiyor — tarayıcı aynı adreste kalıyor.
 */
export function changelogAnchor(slug: string): string {
  return `#${slug}`;
}
